<tr [formGroup]="skjema" data-testid="invitasjon-skjema">
  <td>
    <mat-checkbox [formControl]="skjema.controls.valgt" class="e2e-inkluder"/>
  </td>
  <td>
    <mat-form-field class="navn">
      <mat-label>{{ 'Navn på nytt medlem...'|translate }}</mat-label>
      <input matInput [formControl]="skjema.controls.navn" name="navn" data-testid="navn-felt">
      @if (skjema.controls.navn.hasError('maxlength')) {
        <mat-error data-testid="maxlength">{{ skjema.controls.navn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
      }
      @if (duplikatMedlemFinnes) {
        <mat-hint>
          <i class="icon ion-android-warning"></i>
          {{ 'Medlem med samme navn finnes'|translate }}
        </mat-hint>
      }
    </mat-form-field>
  </td>
  <td>
    <mat-form-field class="epost">
      <mat-label>{{ 'E-postadresse'|translate }}</mat-label>
      <input matInput type="email" [formControl]="skjema.controls.epost" data-testid="epost-felt">
      @if (skjema.controls.epost.hasError('eksistererMedlem')) {
        <mat-error data-testid="eksistererMedlem">{{ 'Det finnes allerede et medlem med denne epostadressen'|translate }}</mat-error>
      }
      @if (skjema.controls.epost.hasError('eksistererInvitasjon')) {
        <mat-error data-testid="eksistererMedlem">{{ 'Det finnes allerede en invitasjon med denne epostadressen'|translate }}</mat-error>
      }
      @if (skjema.controls.epost.hasError('eksistererInaktivt')) {
        <mat-error data-testid="eksistererMedlem">{{ 'Det finnes allerede et inaktivt medlem med denne epostadressen'|translate }}</mat-error>
      }
    </mat-form-field>
  </td>
  <td>
    <mat-form-field class="mobilnummer">
      <mat-label>{{ 'Mobiltelefonnummer'|translate }}</mat-label>
      <mobilnummer-felt [formControl]="skjema.controls.mobilnummer"/>
    </mat-form-field>
  </td>
  <td>
    <mat-form-field class="rolle">
      <mat-label>{{ 'Rolle'|translate }}</mat-label>
      <mat-select [formControl]="skjema.controls.rolle" [compareWith]="erValgtRolle" data-testid="rolle-felt" class="e2e-rolle">
        <mat-option [value]="null">{{ 'Ingen rolle'|translate }}</mat-option>
        @for (rolle of medlemsroller(); track rolle.id) {
          <mat-option [value]="rolle">{{ rolle.tittel }}</mat-option>
        }
      </mat-select>
      @if(skjema.controls.forespurtRolle.value != null){
        <mat-hint>{{'Forspurt rolle "{forespurt}" finnes ikke'|translate:{forespurt: skjema.controls.forespurtRolle.value} }}</mat-hint>
      }
    </mat-form-field>
  </td>
  <td>
    <mat-form-field class="rolle-startdato">
      <mat-label>{{ "Rollens startdato"|translate }}</mat-label>
      <input matInput [matDatepicker]="startdatoVelger" [formControl]="skjema.controls.rolleStartdato" class="e2e-startdato" #startdatofelt>
      <mat-datepicker-toggle matPrefix [for]="startdatoVelger"/>
      <mat-datepicker #startdatoVelger/>
      @if (skjema.controls.rolleStartdato.hasError('matDatepickerParse')) {
        <mat-error data-testid="matDatepickerParse">{{ skjema.controls.rolleStartdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
      }
    </mat-form-field>
  </td>
  <td>
    <mat-form-field class="tilgangsroller">
      <mat-label>{{ 'Tilgang'|translate }}</mat-label>
      <mat-select [formControl]="skjema.controls.tilgangsroller" [compareWith]="erValgtTilgangsrolle" multiple panelWidth="400px" panelClass="medlem-importer-skjemalinje-tilgangsroller" data-testid="rolle-felt">
        <mat-select-trigger>{{tilgangsrollerSomStreng()}}</mat-select-trigger>
        @for (rolleinfo of tilgjengeligeTilgangsroller; track rolleinfo.rolle) {
          <mat-option [value]="rolleinfo.rolle" [disabled]="rolleinfo.obligatorisk">
            <div class="tittel">{{ rolleinfo.tittel(enumOversettelser) }}</div>
            <div class="subtittel">{{ rolleinfo.subtittel(enumOversettelser) }}</div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </td>
  <td>
    <mat-checkbox [formControl]="skjema.controls.oppdaterMoetemal" matTooltip="{{'Fører til at gruppemedlemmet blir lagt til i møtemal og alle fremtidige møter som deltaker'|translate}}"/>
  </td>
  <td>
    <mat-checkbox [formControl]="skjema.controls.skalSignereSomStandard" matTooltip="{{'Fører til at gruppemedlemmet blir lagt til i møtemal og alle fremtidige møter som signatar'|translate}}"/>
  </td>
</tr>
